import { useEffect, useState } from 'react';
import {
  Grid,
  Box,
  Container,
  Stack,
  Typography,
  MenuItem,
  ListItemText,
  ListItemIcon,
  Badge,
  useMediaQuery,
} from '@mui/material';

import { useRouter } from 'next/router';
import Link from 'next/link';

import styles from './header.module.scss';

import {
  RF_LOGO,
  RF_LOGO_WHITE,
  VETERANS_LOGO,
  VETERANS_LOGO_DARK,
  VETRAN_ICON,
  VETRAN_ICON_WHITE,
} from '../../../src/assets/images/global';

import PHONE_ICON from '../../../src/assets/images/icons/phone.svg';
import PHONE_ICON_WHITE from '../../../src/assets/images/icons/phone-white.svg';

import { businessHourTiming } from '../../../commons/utils/utils';

const CustomMenuList = ({
  item,
  color = 'primary.main',
  sx,
  showOnline = false,
}) => {
  const [isOnline, setOnline] = useState(false);

  useEffect(() => {
    setOnline(businessHourTiming());
  }, []);

  return (
    <Link href={item.link} passHref>
      <MenuItem
        tabIndex={0}
        sx={{ ...sx }}
        disableRipple
        className={styles.desktopNavBarMenu}
      >
        {item.icon && (
          <ListItemIcon className={styles.phoneIconMobile}>
            {item.icon}
          </ListItemIcon>
        )}
        <ListItemText className={styles.salesText}>
          {item.title && (
            <Typography variant="h5" color={color}>
              {item.title}
            </Typography>
          )}
        </ListItemText>
        {showOnline && (
          <Badge
            className={`${isOnline ? styles.onlineStatus : styles.offlineStatus}`}
            sx={{ pr: 1, color: 'warning' }}
            variant="dot"
          />
        )}
      </MenuItem>
    </Link>
  );
};

export default function TopHeaderNew({ showSideNav, promoContent }) {
  const router = useRouter();
  const isHome = router.pathname === '/';

  const headerMenu = [
    {
      title: 'Sales: 888-488-3112',
      icon: isHome ? <PHONE_ICON /> : <PHONE_ICON_WHITE />,
      link: 'tel:+1-888-488-3112',
      showOnline: true,
    },
    // {
    //   title: 'Support',
    //   icon: <SUPPORT_ICON />,
    //   link: '/support',
    // },
  ];

  const logoColor = isHome ? 'primary.main' : 'white';

  return (
    <Box sx={{ width: '100%', zIndex: 10004 }}>
      <Box
        className={styles['top-nav-bar']}
        sx={{
          bgcolor: isHome ? 'white' : '#004152',
          py: { sm: 1, xs: 0 },
        }}
        width="100%"
      >
        <Container
          maxWidth="xl"
          sx={{ paddingX: { xl: 0, lg: 5, md: 4, sm: 3, xs: 3 } }}
        >
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            wrap="nowrap"
            className={`${styles.promoContainer} ${
              !promoContent ? styles.promoContainerwithContent : ''
            }`}
          >
            <Grid item className={styles.veteranLogo}>
              {/* Desktop */}
              <Link href="https://www.veteranownedbusiness.com/business/37505/promedev-llc">
                <a target="_blank" rel="noopener noreferrer">
                  <Box className={styles.veteranDesktopLogo}>
                    {isHome ? (
                      <VETERANS_LOGO_DARK width={200} height={35} />
                    ) : (
                      <VETERANS_LOGO width={200} height={35} />
                    )}
                  </Box>
                </a>
              </Link>
              {/* Mobile */}
              <Link href="https://www.veteranownedbusiness.com/business/37505/promedev-llc">
                <a target="_blank" rel="noopener noreferrer">
                  <Box className={styles.veteranMobileLogo}>
                    {isHome ? (
                      <VETRAN_ICON width={30} height={30} />
                    ) : (
                      <VETRAN_ICON_WHITE width={30} height={30} />
                    )}
                  </Box>
                </a>
              </Link>
            </Grid>

            {/* CENTER: RF Logo */}
            <Grid item>
              <Link href="/">
                <Box className={styles.logoMain} component="a">
                  {isHome ? (
                    <RF_LOGO width={162} height={35} />
                  ) : (
                    <RF_LOGO_WHITE width={162} height={35} />
                  )}
                </Box>
              </Link>
            </Grid>

            {/* RIGHT: Contact */}
            <Grid item>
              <Stack
                flexDirection="row"
                justifyContent="flex-end"
                spacing={2}
                className={`${styles.topMenu} ${
                  promoContent ? styles.topMonWithPromo : ''
                }`}
              >
                {headerMenu.map((item, i) => (
                  <CustomMenuList
                    key={i}
                    item={item}
                    index={i}
                    color={logoColor}
                    sx={{ px: 1 }}
                    showOnline={item.showOnline || false}
                  />
                ))}
              </Stack>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
}
